<template><ListFilter field="tier" :options="opts" label="Ярус" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/></template>
<script>
import ListFilter from './ListFilter.vue'
export default { name:'TierFilter', components:{ListFilter}, data(){ return { opts:['Ярус A','Ярус B','Ярус C','Ярус D','Ярус E'] } } }
</script>
